import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { useDocumentUpload } from 'hooks/webapi';
import useError from 'hooks/useError';
import * as R from 'Router/routes';

const useOCRRedirect = () => {
  const { forwardUserToSDK } = useDocumentUpload();
  const { showError } = useError();
  const [hasAcceptedMagicLink, setHasAcceptedMagicLink] =
    useState<boolean>(false);
  const navigate = useNavigate();

  const startMagicLinkFlow = useCallback(() => {
    setHasAcceptedMagicLink(true);
  }, []);

  const goToNextStep = useCallback(() => {
    navigate(R.MANUAL_PSD2_BANKS);
  }, [navigate]);

  const closeMagicLinkModal = useCallback(() => {
    setHasAcceptedMagicLink(false);
  }, []);

  const redirectUserToSMSComponent = useCallback(async () => {
    // case for non-stage envs, skipping directly to manual PSD
    if (
      import.meta.env.VITE_ENV === 'stage' ||
      import.meta.env.VITE_ENV === 'production'
    ) {
      try {
        const redirectUrl = await forwardUserToSDK();
        window.location = redirectUrl?.sessionUrl;
      } catch {
        showError();
      }
    } else {
      navigate(R.MANUAL_PSD2_BANKS);
    }
  }, [forwardUserToSDK]);

  return {
    redirectUserToSMSComponent,
    startMagicLinkFlow,
    goToNextStep,
    closeMagicLinkModal,
    hasAcceptedMagicLink,
  };
};

export default useOCRRedirect;
